module.exports = __webpack_public_path__ + "static/media/pressureForecast.7180390f.png";